module.exports = __webpack_public_path__ + "media/images/svg-sprite-items/sprite-main/logo-printworld-9eb75b05d735e5d83525681584fd7bca.svg";